<template lang="pug">
  v-dialog(v-model="show" :fullscreen="$vuetify.breakpoint.smAndDown"  max-width="700" persistent)
    v-snackbar(v-model="showSnackBar" :color="snackBarColor") {{ snackBarMessage }}
      template(v-slot:action="{ attrs }")
        v-btn.justify-end(fab text v-bind="attrs" @click="showSnackBar = false")
          v-icon fal fa-times-circle
    v-card(flat)
      v-card-text
        v-form(v-model="isFormValid" :lazy-validation="true")
          v-card(flat)
            v-card-title {{ $t('smartLinkPage.searchSmartLink') }}
            v-card-text
              v-text-field(:label=" $t('smartLinkPage.filterOfAddress')" outlined dense v-model="smartLinkName" :error-messages="valueNameIsRequired" )
              v-select(:label=" $t('smartLinkPage.smartLinkType')"  outlined dense v-model="requestKind"
                  append-icon="fas fa-chevron-down"
                  item-text="label"
                  itev-value="name"
                  return-object
                  :loading="isFetchInProgress"
                  :items="requestKindList"
                  @change="onSelectedKindChange")

      v-divider
      v-card-actions
        v-btn( @click="onRemoveFormButtonClick" color="error" :disabled="searchInProgress") {{ $t('smartLinkPage.removeFilter') }}
        v-spacer
        v-btn.pr-2(text @click="onCloseButtonClick" :disabled="searchInProgress") {{ $t('buttons.closeButtonLabel') }}
        v-btn.pr-2(color="primary" @click="onSearchSmartLinkClick" :disabled="isSearchButtonDisabled ||!isFormValid" :loading="searchInProgress") {{ $t('smartLinkPage.searchButtonLabel') }}

</template>

<script lang="ts">
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import SmartLink from "@/model/SmartLink";
import {Action, Getter} from "vuex-class";
import {FETCH_REQUEST_KIND_LIST, SEARCH_SMART_LINK, SET_SMART_LINK_FILTER} from "@/store/action-types";
import {GET_SMART_LINK_FILTER,} from "@/store/getter-types";
import RequestKindList from "@/model/RequestKindList";
import i18n from "@/i18n";
import {TranslateResult} from "vue-i18n";

function valueIsRequired (v: string): boolean | TranslateResult {
  return !!v || i18n.t('validation.valueIsRequired')
}

function nameValidate (v: string): boolean | TranslateResult {
  return /[A-Za-z0-9\t\-\_]+$/.test(v) || i18n.t('smartLinkPage.slugIsTooShort')

}

@Component({
  components: {
  }
})
export default class SmartLinkSearchDialog extends Vue {

  $refs!: {
    menu: Vue & { close: () => boolean }
  }

  @Prop({type: Boolean, default: false}) readonly show!: boolean
  @Prop({type: Boolean, default: false}) readonly filterIsActive!: boolean
  @Prop({type: Array, required: true}) readonly smartLinks!: SmartLink[]
  @Action(SEARCH_SMART_LINK) searchSmartlinks!: { (payload: any): Promise<void> }
  @Action(SET_SMART_LINK_FILTER) setSmartlinks!: { (payload: any): Promise<void> }
  @Getter(GET_SMART_LINK_FILTER) smartLinkFilter!: any[]
  @Action(FETCH_REQUEST_KIND_LIST) fetchRequest!: { (): Promise<RequestKindList[]> }

  private smartLinkName: string = ''
  private requestKind :any | null = null
  private searchInProgress: boolean = false
  private smartLinkNameRules = [
    valueIsRequired,
    nameValidate
  ]
  private slugIsTooShort: boolean = false
  private isFormValid: boolean = false
  private requestKindList: RequestKindList[] = []
  private showSnackBar: boolean = false
  private snackBarColor: string = ''
  private snackBarMessage: string = ''
  private isFetchInProgress: boolean = false

  get getFilter (): any {
    return this.$store.getters[GET_SMART_LINK_FILTER]
  }

  get isSearchButtonDisabled () {
    return false
  }

  get valueNameIsRequired (): string {
    return this.slugIsTooShort ? i18n.t('smartLinkPage.slugIsTooShort').toString() : ''
  }

  onCloseButtonClick (): void{
    this.$emit('close')
  }

  onSelectedKindChange (item: any): void{
  }

  async onSearchSmartLinkClick(): Promise<void>{
    let requestKinds: any[] = []
    if(this.requestKind && this.requestKind.name === 'Prihlásenie na stravu') {
      this.requestKind!.name = 'onboarding'
    }
    let payload = {
      slug:this.smartLinkName && this.smartLinkName.trim().length > 0 ? this.smartLinkName.trim() : null,
      actionKind:'request',
      requestKinds:this.requestKind ? this.requestKind!.name : null
    }
    this.setSmartlinks({
      slug: payload?.slug,
      requestKinds: this.requestKind
    })

    this.searchInProgress = true
    try{
      const response = await this.searchSmartlinks(payload)
      this.$emit('showDetail',response)
      this.searchInProgress = false
      }

    catch (e) {}
}

  onRemoveFormButtonClick (): void{
    this.smartLinkName = ''
    this.requestKind = null
    this.$emit('removeFilter')
  }

  async created (): Promise<void> {
    try {
      this.isFetchInProgress = true
      this.requestKindList = await this.fetchRequest()
      this.isFetchInProgress = false
    } catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('businessPage.fetchDataError').toString()

    } finally {
    }
  }

  mounted(): void {
    if(this.filterIsActive) {
      this.smartLinkName = this.getFilter.slug
      this.requestKind = this.getFilter.requestKinds
    }else {
      this.smartLinkName = ''
      this.requestKind = null
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>
